var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
    version: "0.0.0",
    organization: "Tina",
    project: "AnimatorWebsiteIcon3",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
    core: "4.5.0",
    title: "Deco1",
    type: "haiku",
    relpath: "code/deco1/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco1-b2dcea53f1bacc28": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 11,
        "sizeAbsolute.y": 10,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:6937a4e9fe10": {
        "sizeAbsolute.y": 10,
        "sizeMode.x": 1,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 11,
        "style.margin": "0",
        "style.position": "absolute",
        "sizeMode.y": 1,
        "translation.x": 5.5,
        "translation.y": 5,
        "style.zIndex": 3,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        }
      },
      "haiku:be91a87ef5c0": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:f012d218044c": {
        fill: "#EF33F8",
        "translation.x": -51,
        "translation.y": -46
      },
      "haiku:a3267c039ab1": {
        x: 52.4641016,
        y: 46.9641016,
        width: 8,
        height: 8,
        rx: 2,
        "translation.x": 33.046806,
        "translation.y": -21.404156,
        "rotation.z": 0.523599
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco1-b2dcea53f1bacc28",
      "haiku-title": "Deco1"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "6937a4e9fe10",
          "haiku-title": "deco1",
          "haiku-source":
            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/deco1.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "be91a87ef5c0",
              "haiku-title": "Page-1",
              id: "a6d1a92b457e"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "f012d218044c",
                  "haiku-title": "NPM-icon",
                  id: "8c12bf1b0ca3"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "a3267c039ab1",
                      "haiku-title": "deco1",
                      id: "c008e8ddfe68"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon3/code/deco1/code.js
// module id = 440
// module chunks = 35783957827783